import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=04fca6e8&scoped=true&"
import script from "./CustomerTable.vue?vue&type=script&lang=ts&"
export * from "./CustomerTable.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerTable.vue?vue&type=style&index=0&id=04fca6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fca6e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('04fca6e8', component.options)
    } else {
      api.reload('04fca6e8', component.options)
    }
    module.hot.accept("./CustomerTable.vue?vue&type=template&id=04fca6e8&scoped=true&", function () {
      api.rerender('04fca6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/views/CallCenter/components/CustomerTable.vue"
export default component.exports